import Flex from "common/Boxes/Flex";
import StatisticItem from "features/affiliation/common/StatisticItem";
import { StatisticsTypes } from "features/affiliation/common/types";
import styled from "styled-components";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface StatisticsRowProps<T extends StatisticsTypes> {
  statisticsTitles: T[];
  getStatisticValue: (title: T) => number | string | undefined;
  getLastMonthChangeValue?: (title: T) => number | string | undefined;
}

const StatisticsRow = <T extends StatisticsTypes>({
  statisticsTitles,
  getStatisticValue,
  getLastMonthChangeValue,
}: StatisticsRowProps<T>) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);

  return (
    <Flex style={{ width: "100%" }}>
      {statisticsTitles.map((statisticTitle, index) => (
        <StatisticsWrapper
          key={index}
          $isLast={index === statisticsTitles.length - 1}
        >
          <StatisticItem
            title={t(statisticTitle)}
            value={getStatisticValue(statisticTitle) || 0}
            lastMonthChange={getLastMonthChangeValue?.(statisticTitle)}
          />
        </StatisticsWrapper>
      ))}
    </Flex>
  );
};

export default StatisticsRow;

const StatisticsWrapper = styled.div<{ $isLast: boolean }>`
  flex: 1;
  ${(p) =>
    !p.$isLast &&
    `
    border-right: ${p.theme.borders.light};
    `};
`;
